import { BehaviorSubject } from 'rxjs';

const chartSyncEnabled$ = new BehaviorSubject<boolean>(false);

export const getChartSyncEnabled$ = () => chartSyncEnabled$.asObservable();

export const setChartSyncEnabled = (enabled: boolean) => {
  chartSyncEnabled$.next(enabled);
};

export const isChartSyncEnabled = () => chartSyncEnabled$.getValue();
